import React from 'react';
import {  Button } from 'reactstrap';
import { connect } from 'react-redux';
import { HalfCircleSpinner } from 'react-epic-spinners';
import ReactGA from '../../../utils/analytics';
import { upsertScore } from '../actions';

class Card extends React.Component {
  constructor() {
    super();
    this.state = {
      currentIndex: 0,
      showAnswer: false,
      maxCount: 4,
      fetching: false,
      isMobileDevice: false
    };

    this.next = this.next.bind(this);
    this.score = this.score.bind(this);
    this.showAnswer = this.showAnswer.bind(this);
    this.renderQuestion = this.renderQuestion.bind(this);
    this.isMobileDevice = this.isMobileDevice.bind(this);
  }

  async componentDidMount() {
    const { id } = this.props;
    const { categories } = this.props.selftest;

    // Reset score
    const category = await categories.find(c => c.id === id);
    this.props.dispatch(upsertScore({id: category.id, score: 0}));

    let maxCount = 4;
    const isMobileDevice = this.isMobileDevice();
    if (!isMobileDevice) {
      maxCount = category?.cards?.length;
      this.shuffle(category.cards);
    }

    this.setState({category, isMobileDevice, maxCount});

    // Collect data for Google Analytics
    ReactGA.event({
      category: 'Browsing SelfTest Category',
      action: category.name
    });
  }

  // eslint-disable-next-line class-methods-use-this
  isMobileDevice() {
    const { userAgent } = navigator;
    return /Android|iPhone|iPad|mobile|Windows Phone/i.test(userAgent);
  }

  // eslint-disable-next-line class-methods-use-this
  shuffle(array){
    let i = array.length, j, temp;

    while (--i > 0) {
      j = Math.floor(Math.random () * (i+1));

      temp = array[j];
      array[j] = array[i];
      array[i] = temp;
    }

    return array;
  }

  next() {
    const { currentIndex } = this.state;
    this.setState({showAnswer: false, currentIndex: currentIndex + 1, fetching: true});

    setTimeout(() => this.setState({fetching: false}), 500);
  }

  score() {
    const { category } = this.state;
    this.props.dispatch(upsertScore({id: category.id, score: category.score + 1}))
    this.next();
  }

  showAnswer() {
    this.setState({showAnswer: true});
  }

  renderQuestion() {
    const { currentIndex, showAnswer, category } = this.state;

    const totalScore = `${category?.score} / ${category?.cards?.length}`;
    const cardCount = `${currentIndex + 1} of ${category?.cards?.length}`;
    const currentCard = category?.cards[currentIndex];

    return (
      <div style={{flex: 1, flexDirection: 'column'}}>
        <div style={
          {
            flexDirection: 'column',
            flex: 1,
            margin: 10,
            shadowOffset: {width: -2, height: 4},
            shadowColor: '#171717',
            shadowOpacity: 0.2,
            shadowRadius: 5,
            borderRadius:5,
            borderWidth: 1,
            borderColor: '#cccccc',
            backgroundColor: '#eeeeee',
            padding: 10
          }}
         >
          <div style={{fontSize: 16, color: 'gray',textAlign: 'center', marginTop: 5}}>{currentCard?.question}</div>
          <div style={{fontSize: 20, textAlign: 'center', margin: 10}}>{currentCard?.name}</div>

          <img src={currentCard?.image640} style={{width: '100%', height: 400}} onClick={this.showAnswer} alt={currentCard?.name}/>

          {!showAnswer && (
            <div style={{fontSize: 16, textAlign: 'center', marginTop: 10, color: 'gray'}} onClick={this.showAnswer}>Click image for answer</div>
          )}

          {showAnswer && (
            this.renderAnswer()
          )}

          <div className="d-flex justify-content-between flex-row mt-3 border-top border-gray p-2" >
            <div style={{marginTop: 1}}><div>Score is {totalScore}</div></div>
            <div style={{marginTop: 1}}><div>Card {cardCount}</div></div>
          </div> 
        </div>
      </div>
    );
  }

  renderAnswer() {
    const { currentIndex, category } = this.state;

    const answer = category.cards[currentIndex].short_description;

    return (
      <div >
        <div style={
          {
            flexDirection: 'column',
            flex: 1,
            marginTop: 5,
            borderRadius:5,
            borderWidth: 1,
            borderColor: '#cccccc',
            backgroundColor: 'green',
            padding: 10
          }}
         >
          <div style={{fontSize: 20, fontWeight: 'bold', textAlign: 'center', margin: 5, flex: 1, color: 'white'}}>
            {answer}
          </div>
          <div style={{fontSize: 18, textAlign: 'center', margin: 10, marginTop: 5,flex: 1, color: '#cccccc'}}>
            {category.cards[currentIndex].long_description}
          </div>
         </div>

        <div className="d-flex flex-column m-2" >
          <div style={{textAlign: 'center', marginTop: 10}}>Did you guess the correct answer?</div>
          <div className="d-flex justify-content-between flex-row mt-2" style={{ margin: 1, marginLeft: 20, marginRight: 20}}>
            <Button onClick={this.score} color={'success'} className="text-white">Yes</Button>
            <Button onClick={this.next} color={'danger'}  className="text-white">No</Button>
          </div>
        </div>
      </div>
    );
  }

  renderDone() {
    const { category, maxCount, isMobileDevice } = this.state;
    const totalScore = `${category.score} / ${maxCount}`;
    const totalCards = category.cards.length;

    const scorePcnt = (category.score / totalCards) * 100;
    let judgement; let scoreColour;

    if (scorePcnt < 80) {
      scoreColour = 'red';
      judgement = `Your total score is ${  category.score  } out of ${  totalCards  }. Less than 80%.`;
    } else {
      scoreColour = 'orange';
      judgement = `Your total score is ${  category.score  } out of ${  totalCards  }. More than 80%. Good job!`;
    }
    if (scorePcnt === 100) {
      scoreColour = 'green';
      judgement = 'PERFECT SCORE - you nailed it!';
    }

    return (
      <div className="m-2">
        <div style={
          {
            flexDirection: 'column',
            flex: 1,
            margin: 10,
            marginTop: 30,
            shadowOffset: {width: -2, height: 4},
            shadowColor: '#171717',
            shadowOpacity: 0.2,
            shadowRadius: 5,
            borderRadius:5,
            borderWidth: 1,
            borderColor: '#cccccc',
            backgroundColor: '#eeeeee',
            padding: 10
          }}
         >
          {isMobileDevice && (<div style={{fontSize: 20, color: 'black',textAlign: 'center', marginTop: 20}}>No more cards left in the demo. Full app version has all {category?.cards?.length} cards.</div>)}
          {!isMobileDevice && (<div style={{fontSize: 20, color: 'black',textAlign: 'center', marginTop: 20}}>It's done! No more cards left.</div>)}

          <div style={{fontSize: 16, color: 'gray',textAlign: 'center', marginTop: 20}}>Your Total Score is:</div>
          <div style={{fontSize: 26, textAlign: 'center', margin: 10}}>{totalScore}</div>

          {!isMobileDevice && (<div style={{fontSize: 16, color: scoreColour, textAlign: 'center', margin: 10, marginTop: 20}}>{judgement}</div>)}
        </div>

        <Button onClick={this.props.history.goBack} color="success" className="text-white ">Go Back</Button>
      </div>
    );
  }

  // eslint-disable-next-line class-methods-use-this
  render() {
    const { category, currentIndex, fetching, maxCount, isMobileDevice } = this.state;

    let mobileExtra = '';
    if (isMobileDevice) mobileExtra = `to get the all the ${category?.cards?.length} cards for this category. This demo is limited to ${maxCount} cards.`;

    const showQuestions = (!fetching && currentIndex < maxCount);
    const showDone = (!fetching && currentIndex === maxCount);

    return (
      <>
        {showQuestions && (this.renderQuestion())}
        {showDone && (this.renderDone())}
        {fetching && (
          <div className="d-flex justify-content-center p-5">
            <HalfCircleSpinner color="lightgray" size={80} />
          </div>
        )}
      </>
    );
  }
};

const mapStoreToProps = (store) => ({
  selftest: store.selftest,
});

export default connect(mapStoreToProps)(Card);
